import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Credentials: React.FC = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 }
    }
  };

  const academicCredentials = [
        {
          id: 'edu1',
          title: 'Engenharia Civil',
          institution: 'Universidade Federal do Paraná (UFPR)',
      icon: "🎓"
        },
        {
          id: 'edu2',
          title: 'Pós-graduação em Design de Interiores',
          institution: 'Universidade Positivo',
      icon: "🎓"
        },
        {
          id: 'edu3',
      title: 'Extenção One Year Design & Visual Merchandising',
      institution: 'Istituto Europeo di Design (IED)',
      icon: "🎓"
        },
        {
      id: 'edu4',
      title: 'Mestra em Comunicação e Linguagem',
      institution: 'Universidade Tuiuti do Paraná (UTP)',
      icon: "🎓"
        },
        {
      id: 'edu5',
      title: 'Doutorando em Gestão Ambiental',
      institution: 'Universidade Positivo (UP)',
      icon: "🎓"
    },
        {
          id: 'int1',
          title: 'NRF Retail Conference',
          institution: 'Nova York, EUA',
      icon: "🌎"
        },
        {
          id: 'int2',
          title: 'Módulo Internacional de Design',
          institution: 'Barcelona, Espanha',
      icon: "🌎"
    }
  ];

  return (
    <section className="section bg-neutral-light py-20">
      <div className="container">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-bold text-neutral-dark mb-4"
          >
            Credenciais e Experiência
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-neutral-dark/70 max-w-3xl mx-auto"
          >
            Com formação multidisciplinar e experiência internacional, Raquel
            de Araújo oferece uma perspectiva única que combina técnica,
            estética e estratégia.
          </motion.p>
        </div>

        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={controls}
          className="bg-white p-8 rounded-lg shadow-sm max-w-4xl mx-auto"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            <div>
              <div className="flex items-center mb-6">
                <div className="mr-4 text-3xl text-primary">🎓</div>
                <h3 className="text-xl font-bold text-neutral-dark">Formação Acadêmica</h3>
              </div>
              <div className="space-y-6">
                {academicCredentials.slice(0, 5).map((item) => (
            <motion.div 
                    key={item.id} 
              variants={itemVariants}
                    className="border-l-2 border-primary pl-4 hover:bg-neutral-light/50 transition-colors p-2 rounded"
                  >
                    <h4 className="font-bold text-neutral-dark">{item.title}</h4>
                    <p className="text-sm text-neutral-dark/70">{item.institution}</p>
                  </motion.div>
                ))}
              </div>
            </div>
            
            <div>
              <div className="flex items-center mb-6">
                <div className="mr-4 text-3xl text-primary">🌎</div>
                <h3 className="text-xl font-bold text-neutral-dark">Experiência Internacional</h3>
              </div>
              <div className="space-y-6">
                {academicCredentials.slice(5).map((item) => (
                  <motion.div 
                    key={item.id} 
                    variants={itemVariants}
                    className="border-l-2 border-primary pl-4 hover:bg-neutral-light/50 transition-colors p-2 rounded"
                  >
                    <h4 className="font-bold text-neutral-dark">{item.title}</h4>
                    <p className="text-sm text-neutral-dark/70">{item.institution}</p>
                  </motion.div>
                ))}
              </div>
              
              <motion.div 
                variants={itemVariants}
                className="mt-10 pt-6 border-t border-primary/10"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center text-primary">
                    <span className="text-lg">+</span>
                  </div>
                  <p className="text-neutral-dark/80 italic">Participação em eventos, workshops e cursos internacionais de design e visual merchandising.</p>
                </div>
              </motion.div>
            </div>
          </div>
          
          <motion.div 
            variants={itemVariants}
            className="mt-8 pt-8 border-t border-primary/10 text-center"
          >
            <p className="text-neutral-dark/70">Uma abordagem multidisciplinar que combina conhecimentos técnicos, estéticos e estratégicos para criar soluções que elevam espaços e marcas.</p>
            </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Credentials; 